import React from 'react';
import { AdminLayout } from '.';

// TO-DO: Add a check so that non-admin users can't view this page
export const AdminPage = () => {
    return (
        <AdminLayout>
            <div>Welcome to Admin page</div>
        </ AdminLayout >
    );
};

export default AdminPage;  